<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M10.853 4.13097C11.288 3.12797 12.712 3.12797 13.147 4.13097L15.127 8.69697L20.081 9.16897C21.169 9.27197 21.609 10.626 20.789 11.35L17.059 14.644L18.141 19.501C18.379 20.569 17.227 21.405 16.285 20.849L12 18.32L7.71501 20.85C6.77301 21.406 5.62101 20.57 5.85901 19.502L6.94101 14.645L3.21101 11.351C2.39101 10.627 2.83101 9.27297 3.92001 9.16997L8.87301 8.69797L10.853 4.13197V4.13097ZM12 6.51397L10.473 10.034L10.239 10.576L9.65101 10.632L5.83101 10.996L8.70701 13.536L9.15001 13.926L9.02201 14.502L8.18701 18.248L11.492 16.297L12 15.997L12.508 16.297L15.813 18.247L14.978 14.502L14.85 13.926L15.293 13.536L18.169 10.996L14.349 10.632L13.761 10.576L13.527 10.034L12 6.51397Z"
			:fill="color"
		/>
	</svg>
</template>

<script>
export default {
	props: {
		color: {
			type: String,
			default: '#597393',
		},
	},
};
</script>
